import {
  IAmountDiscount,
  IDiscount,
  IPercentageDiscount,
} from '@/common/integrations/menhir/employee/discounts/discounts.types';

export const isPercentageDiscount = (
  discount: IDiscount
): discount is IPercentageDiscount => discount.type === 'percentage';

export const isAmountDiscount = (
  discount: IDiscount
): discount is IAmountDiscount => discount.type === 'amount';
